module.exports = __webpack_public_path__ + "static/img/case_6.e68b2405.jpg";